
export function HtmlToPlain() {
    return (text) => {
        return text ? text.replace(/<[^>]+>/gm, '') : '';
    }
}

